/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDetector extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDetector");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDetector.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDetector>): BackgroundJobPayloadForCostAnomalyDetector {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDetector(), model);
        BackgroundJobPayloadForCostAnomalyDetector.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDetector>): BackgroundJobPayloadForCostAnomalyDetector {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDetector.newInstance(<BackgroundJobPayloadForCostAnomalyDetector> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDetector) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDetector.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDetector): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDetector.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
